<div class="container-fluid">

    <h4 id="upper">Budget ({{ this.annee}}) par programme </h4>
    <div class="d-flex justify-content-end">


        <div class="dropdown d-inline-block " ngbDropdown>
            <button type="button" ngbDropdownToggle class="btn btn-secondary dropdown-toggle" id="dropdownMenuButton"
                aria-haspopup="true" aria-expanded="false">
                Exporter <i class="pi pi-upload" style="font-size: 0.8rem"></i>

            </button>
            <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu aria-labelledby="dropdownMenuButton">
                <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('pdf')">Au format
                    PDF</a>
                <a class="dropdown-item" href="javascript:void(0);" (click)="exportToDocument('excel')">Au format
                    Excel</a>
            </div>

        </div>
    </div><br>



    <div class="row">
        <div class="col-lg-12">
            <div class="card">

                <div class="card-body">

                    <div class="table-responsive mt-3">
                        <table class="table table-centered datatable dt-responsive nowrap"
                            style="border-collapse: collapse; border-spacing: 0; width: 100%;">
                            <thead class="thead-light  rwd-table">
                                <tr>
                                    <th >Code</th>
                                    <th  >Programme</th>
                                    <th class="text-end" style="white-space: nowrap;">Poids (%)</th>
                                    <!-- <th class="text-end" style="white-space: nowrap;">Fond propre</th>
                                    <th  class="text-end"style="white-space: nowrap;">FADEC</th>
                                    <th  class="text-end"style="white-space: nowrap;">FADEC non affect.</th>
                                    <th  class="text-end"style="white-space: nowrap;">PTF</th> -->
                                    <th  class="text-end"style="white-space: nowrap;">Total</th>
                                    <th  class="text-end"style="white-space: nowrap;"> Tep Prévu</th>
                                    <th  class="text-end"style="white-space: nowrap;"> Tep realisé</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let item of paginatedProjets; let index = index">
                                    <td >{{item?.programme.code}}</td>
                                    <td >{{item?.programme.libelle}}</td>
                                    <td  class="text-end">{{ item?.programme.poids }}</td>
                                    <!-- <td class="text-end">{{ item?.montant_fond_propre  | formatMoney:null}}</td>
                                    <td class="text-end">{{ item?.montant_fadec | formatMoney:null }}</td>
                                    <td class="text-end">{{ item?.montant_non_fadec | formatMoney:null }}</td>
                                    <td  class="text-end">{{ item?.montant_ptf  | formatMoney:null}}</td> -->
                                    <td class="text-end">{{ item?.montant_total | formatMoney:null }}</td>
                                    <td class="text-end">{{ item?.tep_prevu | number:'1.2-2' }}</td>
                                    <td class="text-end">{{ item?.tep_realise | number:'1.2-2' }}</td>


                                </tr>

                                <tr *ngIf="projetData.length === 0 && isLoading === false">
                                    <td colspan="8">
                                        <div class="row">
                                            <div class="text-center">
                                                <h5 id="graycolor">Aucune donnée trouvée</h5>
                                            </div>
                                        </div>
                                    </td>
                                </tr>

                            </tbody>
                        </table>
                    </div>

                    <p-paginator (onPageChange)="onPageChangeProjets($event)" [first]="firstProjets"
                        [rows]="rowsProjets" [totalRecords]="totalRecords" [rowsPerPageOptions]="[10, 20, 30]" />
                </div>
            </div>

        </div>

    </div>

    <!-- Graphique Budget par Programme -->
    <div class="row mb-4" *ngIf="barChartData && barChartData.labels?.length > 0">
        <div class="col-lg-12">
            <div class="card">
                <div class="card-body">
                    <h5 class="card-title mb-3">Graphique du budget par programme</h5>
                    <div style="height: 400px;">
                        <p-chart type="bar" [data]="barChartData" [options]="barChartOptions"></p-chart>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<p-confirmDialog />
<p-toast />
<ngx-ui-loader></ngx-ui-loader>
